const options = Array.from({ length: 9 }, (_, i) => i + 2)

function LoanLengthOptions() {
  return (
    <>
      {options.map((value, index) => {
        return (
          <option
            key={'select-' + index}
            value={value}
            data-option-value={value}
          >
            {`${value} år`}
          </option>
        )
      })}
    </>
  )
}

export default LoanLengthOptions
